import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const init = () => {

    var $swipers = $('.promo--swiper .swiper-container');
    $swipers.each(function(i, el) {
        var $parent = $(el).closest('.promo--swiper');
        var pag = $parent.find('.swiper-pagination')[0];
        var next = $parent.find('.swiper-button-next')[0];
        var prev = $parent.find('.swiper-button-prev')[0];
        var swiper = new Swiper(el, {
            modules: [Navigation, Pagination],
            pagination: {
                el: pag,
                clickable: true
            },
            navigation: {
                nextEl: next,
                prevEl: prev
            },
            slidesPerView: 1,
            spaceBetween: 40,
            lazyLoading: true,
            lazyLoadingOnTransitionStart: true,
            preloadImages: false,
            loop: true
        });
    });

}

export default init;
